import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import '../../node_modules/msal/dist/msal.js';



import { CONFIG } from '../config';
import '../rxjs-extensions';
import * as Msal from 'msal';
const CONFIG2 = CONFIG.Settings;

@Injectable()
export class AuthHelper {
  public access_token = null;

  public app: Msal.UserAgentApplication = null;
  public user;
  public isAuthenticated = false;

  constructor() {
    const logger = new Msal.Logger(this.loggerCallback, { level: Msal.LogLevel.Verbose, correlationId: '12345' });
    this.app = new Msal.UserAgentApplication(CONFIG2.CLIENT_ID, CONFIG2.AUTHORITY, this.authCallback, {
      logger: logger, cacheLocation: 'localStorage',
      redirectUri: CONFIG2.REDIRECT_URI,
      navigateToLoginRequestUrl: false,
    });
  }

  public loggerCallback(logLevel, message, piiLoggingEnabled) {
    console.log(message);
  }

  authCallback = (errorDesc, token, error, tokenType) => {
    this.app.acquireTokenSilent(CONFIG2.SCOPES).then(
      accessToken => {
        this.access_token = accessToken;
        //console.log('ACCESS TOKEN: \n ' + this.access_token);
        this.user = this.app.getUser(); // AZURE AD
        this.isAuthenticated = true;
      },
      acquireTokenSilentError => {
        //console.log('acquireTokenSilent- Error:\n' + acquireTokenSilentError);
      }
    );
  }

  public loginPopup() {
    return this.app.loginPopup(CONFIG2.SCOPES).then((idToken) => {
      this.app.acquireTokenSilent(CONFIG2.SCOPES).then(
        (token: string) => {
          return Promise.resolve(token);
        }, (error: any) => {
          this.app.acquireTokenPopup(CONFIG2.SCOPES).then(
            (token: string) => {
              return Promise.resolve(token);
            }, (innererror: any) => {
              return Promise.resolve('');
            });
        });
    }, (error: any) => {
      console.log('Error during login:\n' + error);
      return Promise.resolve('');
    });
  }
  private loginRedirect() {
    this.app.loginRedirect(CONFIG2.SCOPES);
    return this.getToken().then(() => {
      Promise.resolve(this.app.getUser());
    });
  }

  public login() {
    return this.loginRedirect();
  }

  public logout() {
    this.app.logout();
  }
  public clearCache() {
    //this.app.clearCache();
  }

  public isOnline(): boolean {
    return this.app.getUser() != null;
  }

  public getCurrentLogin() {
    const user = this.app.getUser();
    return user;
  }
  public getToken() {
    return this.app.acquireTokenSilent(CONFIG2.SCOPES).then(accessToken => {
      return accessToken;
    },
      error => {
        return this.app.acquireTokenSilent(CONFIG2.SCOPES).then(accessToken => {
          return accessToken;
        },
          err => {
            console.error(err);
          });
      });
  }


}